import React, { useEffect } from 'react'
import moment from 'moment'

import {
  Box,
  Grid,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from '../Barcode'
import { Order } from '../../api/models'

const useStyles = makeStyles(() => ({
  table: {
    maxWidth: '80%',
    margin: 'auto',
    marginTop: '2rem',
  },
  label: {
    maxWidth: '90%',
    margin: 'auto',
    border: '1px solid gray',
    borderRadius: '1rem',
    padding: '0.5rem',
  },
  leftColumnData: {
    borderLeft: '1px solid gray',
    borderRight: '1px solid gray',
    padding: '4px',
  },
  rightColumnData: {
    borderRight: '1px solid gray',
    padding: '4px',
  },
  rowData: {
    borderTop: '1px solid gray',
    borderBottom: '1px solid gray',
  },
}))

const billableActivity = [
  'Ecomm Order Processing',
  'Freight Order Processing/B2B',
  'Rush Order Fee',
  'Pallet handling Out',
  'Case pick Out',
  'Unit Pick Out',
  'Labeling Fee',
  'Pallet Supply',
  'Pallet Wrap',
  'Labor',
  'Shipping Material (use codes & qty)',
  'Shipping Charge',
  'Misc Charge',
]

const responsibleInfo = ['Picked by', 'Processed by', 'Freight Order Location']

interface Props {
  order: Order
  short?: boolean
  onLoaded?: () => void
}

export const OrderLabel = (props: Props) => {
  const { order, short = false, onLoaded } = props
  const barcode = { barcode: order.guid, type: 'datamatrix', displayName: '' }
  const classes = useStyles()

  useEffect(() => {
    onLoaded?.()
  }, [onLoaded])

  return (
    <div className="always-page-break">
      <Box px={10} pt={20}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={4}
          className={classes.label}
        >
          <Grid item xs={3}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item xs={9}>
            <Box>
              <Typography variant="h1">Order #{order.number}</Typography>
              <Typography variant="h2">Client: {order.client?.name}</Typography>
            </Box>
            <Grid container spacing={1}>
              <Grid item xs={9}>
                <Typography variant="h5">{order.guid}</Typography>
                <Typography variant="caption">Printed on {moment().format('lll')}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="h5">Status</Typography>
                <Typography variant="body1">{order.status}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            {order?.customFields && order.customFields.map((cf) => (
              <>
                <Grid item>
                  <Typography variant="h6">{cf.label}</Typography>
                  <Typography variant="body1">{cf.value}</Typography>
                </Grid>
              </>
            ))}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Order Details</Typography>
            <Typography variant="body1">{order.details}</Typography>
          </Grid>
        </Grid>
        {short && (
          <>
            <Table className={classes.table} size="small">
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '60%' }}>Billabe Activity</TableCell>
                  <TableCell align="center">Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {billableActivity.map((item) => (
                  <TableRow key={item} className={classes.rowData}>
                    <TableCell className={classes.leftColumnData}>{item}</TableCell>
                    <TableCell className={classes.rightColumnData}></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Table className={classes.table} size="small">
              <TableBody>
                {responsibleInfo.map((item) => (
                  <TableRow key={item} className={classes.rowData}>
                    <TableCell className={classes.leftColumnData} style={{ width: '40%' }}>
                      {item}
                    </TableCell>
                    <TableCell className={classes.rightColumnData}></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </Box>
    </div>
  )
}
